import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('layout', ['expanded']),
    primaryNavVisible: {
      get () {
        return this.expanded
      },
      set (val) {
        this.$store.dispatch(`layout/${val ? 'expand' : 'collapse'}`)
      }
    }
  },
  methods: {
    togglePrimaryNav () {
      this.$store.dispatch('layout/toggle')
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/src/mixins/primary_nav.js